var vehicle_types = [
    {
        "label": "Compact Car",
        "val": "compact_car"
    },
    {
        "label": "Sedan",
        "val": "sedan"
    },
    {
        "label": "SUV",
        "val": "suv"
    },
    {
        "label": "Minivan",
        "val": "minivan"
    },
    {
        "label": "1/2 Ton Pickup",
        "val": "pickup_truck"
    },
    {
        "label": "1 Ton Pickup",
        "val": "truck"
    },
    {
        "label": "Sprinter Van",
        "val": "sprinter_van"
    },
    {
        "label": "Box Truck",
        "val": "box_truck"
    },
    {
        "label": "Semi/Tractor",
        "val": "tractor_semi"
    }
]

module.exports = vehicle_types;